import React, { useEffect, useState } from "react";
import { Button, Container, Modal, Table } from "react-bootstrap";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import Pagination from "../../../Utility/Pagination/Pagination";
import notify from "../../../Notifcation";
import {
  DeleteAdminRequestAction,
  GetAllAdminRequestAction,
} from "../../../../redux/actions/AdminRequestAction";
import { useTableExcelExport } from "../../../Utility/useTableExcelExport";
import { filterByEmployeeName } from "../../../Utility/FormPrintView/formPrintHelpers";
import dayjs from "dayjs";

const Display = ({
  userData,
  key,
  setKey,
  Datee,
  setDate,
  DateFrom,
  setDateFrom,
  DateTo,
  setDateTo,
  TimeFrom,
  setTimeFrom,
  TimeTo,
  setTimeTo,
  Request,
  setRequest,
  ApprovedById,
  setApprovedById,
  approvedByName,
  setApprovedByName,
  NumberOfHours,
  NumberOfDays,
  Months,
  time,
  settime,
  Day,
  setDay,
  showCircleType,
  setshowCircleType,
  showSefam,
  setshowSefam,
  duration,
  setDuration,
  showSefak,
  setshowSefak,
  selectedFile,
  setSelectedFile,
  NoteFile,
  setNoteFile,
  Note,
  setNote,
  FileeBase64,
  setBase64,
  EmployeesId,
  setEmployeesId,
  isEdit,
  setIsEdit,
  Eye,
  setEye,
  AdminrequestId,
  setAdminrequestId,
  setNumberOfDays,
  setNumberOfHours,
  NumberOfAvaDays,
  setNumberOfAvaDays,
  BorrowValue,
  setBorrowValue,
}) => {
  const [Dateeto, setDateto] = useState("");
  const [Dateefrom, setDatefrom] = useState("");
  const [isPress, setIsPress] = useState(false);
  const [Searchkey, setSearchkey] = useState("");
  const [loading, setLoading] = useState(true);
  const PageSize = 7;
  const { tableRef, onDownload } = useTableExcelExport(
    "بيانات الطلبات",
    "بيانات الطلبات",
  );
  const [showDelete, setshowDelete] = useState(false);
  const All = useSelector((state) => state.AdminRequestR.GetAdminRequest);
  const dispatch = useDispatch();

  const buildSearchQuery = (page = 1) => {
    const query = { pageNumber: page, pageSize: PageSize };
    if (Dateefrom) query.from = Dateefrom;
    if (Dateeto) query.to = Dateeto;
    if (Request) query.request = Request;
    if (Searchkey.trim()) query.searchTerm = Searchkey.trim();
    return query;
  };

  const filteredRequests = filterByEmployeeName(All?.data, Searchkey);

  const handleCloseDelete = () => setshowDelete(false);
  const handleShoweDelete = (itemid) => {
    setshowDelete(true);
    setAdminrequestId(itemid);
  };
  const onPress = async (page) => {
    await dispatch(GetAllAdminRequestAction(buildSearchQuery(page)));
  };

  const handelDeleteItem = async () => {
    setIsPress(true);
    setLoading(true);
    await dispatch(DeleteAdminRequestAction(AdminrequestId));
    setLoading(false);
    setAdminrequestId(null);
    setshowDelete(false);
    setIsPress(false);
  };

  const Update = (item) => {
    setKey("enter");
    setEmployeesId({
      name: item.employeeName,
      id: item.employeeId,
    });
    setDate(item.date);
    setRequest(item.request);
    setNote(item.note);
    setBorrowValue(item.borrowValue);

    setDateFrom(item.dateFrom);
    setDateTo(item.dateTo);
    setTimeFrom(dayjs(`1970-01-01T${item.timeFrom}`));
    setTimeTo(dayjs(`1970-01-01T${item.timeTo}`));

    setNumberOfDays(item.numberOfDays);
    setNumberOfHours(item.numberOfHours);
    setAdminrequestId(item.id);
    setApprovedById(item.approvedById !== 0 ? true : false);
    setApprovedByName(item.approvedByName || "");
    setNoteFile(item.fileDescription);

    setIsEdit(true);
    setEye(false);
  };
  const Showw = (item) => {
    setKey("enter");
    setEmployeesId({
      name: item.employeeName,
      id: item.employeeId,
    });
    setDate(item.date);
    setRequest(item.request);
    setNote(item.note);
    setDateFrom(item.dateFrom);
    setBorrowValue(item.borrowValue);
    setDateTo(item.dateTo);
    setTimeFrom(
      item.timeFrom !== null ? dayjs(`1970-01-01T${item.timeFrom}`) : "",
    );
    setTimeTo(item.timeTo != null ? dayjs(`1970-01-01T${item.timeTo}`) : "");
    setNoteFile(item.fileDescription);

    setNumberOfDays(item.numberOfDays);
    setNumberOfHours(item.numberOfHours);
    setAdminrequestId(item.id);
    setApprovedById(item.approvedById !== 0 ? true : false);
    setApprovedByName(item.approvedByName || "");

    setIsEdit(false);
    setEye(true);
  };

  useEffect(() => {
    dispatch(GetAllAdminRequestAction(buildSearchQuery()));
  }, [Dateeto, Dateefrom, Request]);

  const handleSubmit = async () => {
    await dispatch(GetAllAdminRequestAction(buildSearchQuery()));
  };

  const DEL = useSelector((state) => state.AdminRequestR.DeleteAdminRequest);
  useEffect(() => {
    if (loading === false) {
      setTimeout(() => setLoading(true), 2000);
      if (DEL) {
        if (DEL.statusCode === 200 || DEL.statusCode === 201) {
          if (
            DEL &&
            DEL.responseMessage === "Great, admin request deleted successfully"
          ) {
            dispatch(GetAllAdminRequestAction(buildSearchQuery()));
            notify("تم حذف البيانات بنجاح", "success");
          }
        } else if (DEL.statusCode !== 200 || DEL.statusCode !== 201) {
          notify("حدث خطأ حاول مرة اخرى", "error");
        }
      }
    }
  }, [loading]);

  return (
    <>
      <div className="enterr">
        <Container>
          <div className="inputs-container">
            <div className="inp-container">
              <div className="dateee">
                {Dateefrom ? Dateefrom.split("-").reverse().join("-") : null}
              </div>
              <i className="ty fa-solid fa-calendar-days"></i>
              <TextField
                label="التاريخ من"
                variant="outlined"
                type="date"
                value={Dateefrom}
                onChange={(e) => setDatefrom(e.target.value)}
              />
            </div>
            <div className="inp-container">
              <div className="dateee">
                {Dateeto ? Dateeto.split("-").reverse().join("-") : null}
              </div>
              <i className="ty fa-solid fa-calendar-days"></i>
              <TextField
                label="التاريخ إلى"
                variant="outlined"
                type="date"
                value={Dateeto}
                onChange={(e) => setDateto(e.target.value)}
              />
            </div>

            <div className="inp-container">
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  {" "}
                  <Typography sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                    طلب إداري
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={Request}
                  label={
                    <Typography
                      sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                      طلب إداري
                      <span style={{ color: "red", fontSize: "21px" }}>*</span>
                    </Typography>
                  }
                  onChange={(e) => {
                    setRequest(e.target.value);
                  }}>
                  <MenuItem value={"RegularLeave"}>اجازة اعتيادية</MenuItem>
                  <MenuItem value={"EmergencyLeave"}>اجازة عارضة</MenuItem>
                  <MenuItem value={"AnnualLeave"}>اجازة سنوية</MenuItem>
                  <MenuItem value={"SickLeave"}>اجازة مرضي</MenuItem>
                  <MenuItem value={"PermissionToLeave"}> اذن انصراف</MenuItem>
                  <MenuItem value={"PermissionForDelay"}> اذن تأخير</MenuItem>
                  <MenuItem value={"OfficialTaskPermit"}> اذن مأمورية</MenuItem>
                  <MenuItem value={"ComplaintRequest"}>طلب شكوى</MenuItem>
                  <MenuItem value={"InquiryRequest"}> طلب استفسار</MenuItem>
                  <MenuItem value={"BorrowRequest"}> طلب سلفة</MenuItem>
                </Select>
              </FormControl>
            </div>
            
            <div className="inp-container ">
              <TextField
                label="ابحث"
                variant="outlined"
                value={Searchkey}
                onChange={(e) => setSearchkey(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleSubmit();
                }}
              />
              <i
                className="ty fa-solid fa-magnifying-glass"
                onClick={handleSubmit}></i>
            </div>
            <div className="inp-container">
              
            </div>
            <div className="inp-container"></div>
          </div>
          <button className="buttonadd" onClick={handleSubmit}>
            بحث
          </button>
        </Container>
        <Table
          ref={tableRef}
          id="my-table"
          className="maint"
          responsive
          striped
          bordered
          hover>
          <thead>
            <tr>
              <th>
                التاريخ<i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                اسم الموظف <i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                نوع الطلب <i className="fa-regular fa-calendar-check"></i>
              </th>
              <th>
                من<i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                إلى<i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                عدد<i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                ادخال / مراجعة <i className="fa-regular fa-calendar-check"></i>
              </th>
              <th>
                ملاحظات <i className="fa-regular fa-calendar-check"></i>
              </th>

              <th className="icon-w"> </th>
              <th className="icon-w"> </th>
              <th className="icon-w"> </th>
            </tr>
          </thead>
          <tbody>
            {filteredRequests.length > 0
              ? filteredRequests.map((item, idx) => {
                  return (
                    <tr key={idx} onDoubleClick={() => Update(item)}>
                      <td>{new Date(item.date).toLocaleDateString("en-GB")}</td>
                      <td>{item.employeeName}</td>
                      <td>
                        {item.request === "RegularLeave"
                          ? "اجازة اعتيادية"
                          : item.request === "EmergencyLeave"
                            ? "اجازة عارضة"
                            : item.request === "AnnualLeave"
                              ? "اجازة سنوية"
                              : item.request === "SickLeave"
                                ? "اجازة مرضي"
                                : item.request === "PermissionToLeave"
                                  ? "اذن انصراف"
                                  : item.request === "PermissionForDelay"
                                    ? "اذن تأخير"
                                    : item.request === "OfficialTaskPermit"
                                      ? "اذن مأمورية"
                                      : item.request === "ComplaintRequest"
                                        ? "طلب شكوى"
                                        : item.request === "InquiryRequest"
                                          ? "طلب استفسار"
                                          : item.request === "BorrowRequest"
                                            ? "طلب سلفة"
                                            : ""}
                      </td>
                      <td>
                        {item.timeFrom !== null
                          ? item.timeFrom
                          : item.dateFrom !== null
                            ? new Date(item.dateFrom).toLocaleDateString(
                                "en-GB",
                              )
                            : ""}
                      </td>
                      <td>
                        {item.timeTo !== null
                          ? item.timeTo
                          : item.dateTo !== null
                            ? new Date(item.dateTo).toLocaleDateString("en-GB")
                            : ""}
                      </td>
                      <td>
                        {item.numberOfDays !== null
                          ? item.numberOfDays + " أيام"
                          : item.numberOfHours !== null
                            ? item.numberOfHours
                            : ""}
                      </td>
                      <td>{item.approvedByName}</td>
                      <td>{item.note}</td>
                      <td className="icon-w" onClick={() => Update(item)}>
                        <i
                          className="fa fa-solid fa-pen-to-square icon-blue"
                          style={{ color: "#333" }}></i>
                      </td>
                      <td className="icon-w">
                        <i
                          onClick={() => handleShoweDelete(item.id)}
                          className="fs fa-solid fa-trash-can icon-red"
                          style={{ color: "#333" }}></i>
                      </td>
                      <td className="icon-w">
                        <i
                          onClick={() => Showw(item)}
                          className="fa-solid fa-eye"
                          style={{ color: "#333" }}></i>
                      </td>
                    </tr>
                  );
                })
              : null}
          </tbody>
        </Table>
        <ToastContainer autoClose={1200} />
        <Pagination
          onPress={onPress}
          PageSize={PageSize}
          PageCount={All ? All.totalPages : null}
        />
        <div className="mod">
          <Modal
            show={showDelete}
            onHide={handleCloseDelete}
            backdrop="static"
            centered
            contentClassName="cont"
            keyboard={false}
            style={{ width: "100%", margin: "0px auto", textAlign: "center" }}>
            <Modal.Body>هل تريد الحذف ؟ </Modal.Body>

            <Modal.Footer>
              <Button
                variant="secondary"
                className="close"
                onClick={handleCloseDelete}>
                إغلاق
              </Button>
              <Button
                variant="primary"
                className="edit"
                onClick={handelDeleteItem}>
                موافق
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
        <button className="buttonadd" onClick={onDownload}>
          تصدير
        </button>
      </div>
    </>
  );
};
export default Display;
